<ng-container
  #provider

  provideElements
  [documentId]="boDocumentId"
  [reportIndex]="boReportIndex"
  [funds]="selectedFund"

  chartBinding

  timeframePreselection
  [timeframeSelector]="tfs"

  chartTimeframeController
  [timesframes]="'Timeframes' | element | async | dataToTimeframes"
  [chartTimeframeSelector]="tfs.timeframe$">

  <div
    class="fond-detail-header"
    [attr.invisible]="chartProvider.loading() ? true : null">

    <div class="sd-headline sd-headline--size-xl">
      {{ nameElement | element | async | elementContentString }}
    </div>

    <wct-time-frame-selection
      #tfs
      [activeButtons]="'Timeframes' | element | async | dataToTimeframes" />

    <div class="sd-meta fond-detail-header-value">
      {{ valueElement | element | async | elementContentString }}
    </div>

  </div>

  <div
    class="fund-detail"
    [attr.invisible]="chartProvider.loading() ? true : null">

    <wct-element-host
      class="stockgraph-no-lines"
      [element]="(chartElement | element | async) || (chartElementBmk | element | async)"
      [options]="chartOptions" />

    <sd-4-5-1-divider orientation="vertical"></sd-4-5-1-divider>

    <wct-element-host
      #tableRef

      [element]="tableElement | element | async"
      [options]="tableOptions"
      [hideIfNoElement]="false"

      [class.wct-loading-fade-children]="tableProviderElement?.loading()"

      provideElements
      [documentId]="boDocumentId"
      [reportIndex]="boReportIndex"
      [funds]="selectedFund"
      [parameters]="tfs.timeframe$ | async | tableParameters"

      wctLoadingIndicator
      [apiSignal]="undefined"
      [apiCallAdditionalLoading]="tableProviderElement?.loading ?? null" />
  </div>

  @if (chartProvider.loading()) {
    <sd-4-5-1-spinner class="wct-absolute-center"></sd-4-5-1-spinner>
  }
</ng-container>
